import { createWebHistory, createRouter } from "vue-router";

import axios from 'axios';
import routes from './routes'
import appConfig from "../../app.config";
import store from "@/state/store";
import { ls } from "@/state/secureStore";

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, left: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  
  if (!authRequired) return next()
  // else return next({ name: 'oturum-ac', query: { redirectFrom: routeTo.fullPath } })

  axios.defaults.headers.common['authorization'] = 'Bearer ' + ls.get('jwt') // for all requests
  
  if(store.getters["userAuth/loggedIn"]){
    next()
  } else {
    next({ name: 'oturum-ac', query: { redirectFrom: routeTo.fullPath } })
  }
  // if (localStorage.getItem('up') == undefined){
  //   next({ name: 'oturum-ac', query: { redirectFrom: routeTo.fullPath } })
  // }
  // let user = JSON.parse(localStorage.getItem('up'))
  // let data = new FormData();
  // data.append('token', 'furkan')
  // data.append('username', user['u'])
  // data.append('password', user['p'])
  // await axios.post('https://elektromarketim.net/api/login/', data).then((data) => {
  //   console.log(data)
  //   localStorage.setItem("userdata", JSON.stringify(data.data.result[0]));
  //   localStorage.setItem("userid", data.data.result[0]['ccustno'])
  //   next()
  // }).catch(() => {
  //   next({ name: 'oturum-ac', query: { redirectFrom: routeTo.fullPath } })
  // });
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }
  document.title = routeTo.meta.title + ' | ' + appConfig.title;
  // If we reach this point, continue resolving the route.
  next()
})

export default router
